import Modal from 'antd/es/modal';
import { useState } from 'react';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { ReceiverFormContent } from './ReceiverFormContent';

import {
  CREATE_RECEIVER_CONFIRM_DIALOG_TEST_ID,
  CREATE_RECEIVER_CONFIRM_NO_TEST_ID,
  CREATE_RECEIVER_CONFIRM_YES_TEST_ID,
  EXIT_UNFINISHED_RECEIVER_BODY,
  EXIT_UNFINISHED_RECEIVER_TITLE
} from '../constants';

type Props = {
  open: boolean;
  onClose: () => void;
  setKey: (key: number) => void;
};

export const CreateReceiverDialog = ({ open, onClose, setKey }: Props) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleCancel = () => setConfirmOpen(true);

  const handleConfirmYes = () => {
    setConfirmOpen(false);
    onClose();
  };

  return (
    <>
      <Modal
        title="Create New Receiver"
        open={open}
        onCancel={handleCancel}
        keyboard={false}
        maskClosable={false}
        footer={false}
      >
        <ReceiverFormContent
          onCancel={handleCancel}
          onSuccessClose={onClose}
          setKey={setKey}
        />
      </Modal>

      <Modal
        title={EXIT_UNFINISHED_RECEIVER_TITLE}
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        maskClosable={false}
        keyboard={false}
        destroyOnHidden
        data-testid={CREATE_RECEIVER_CONFIRM_DIALOG_TEST_ID}
        footer={
          <div className="flex justify-end gap-2">
            <PrimaryButton
              data-testid={CREATE_RECEIVER_CONFIRM_NO_TEST_ID}
              onClick={() => setConfirmOpen(false)}
            >
              No
            </PrimaryButton>
            <PrimaryButton
              danger
              data-testid={CREATE_RECEIVER_CONFIRM_YES_TEST_ID}
              onClick={handleConfirmYes}
            >
              Yes
            </PrimaryButton>
          </div>
        }
      >
        <p>{EXIT_UNFINISHED_RECEIVER_BODY}</p>
      </Modal>
    </>
  );
};
